module.exports = __webpack_public_path__ + "static/img/252_phase_function_Paper_Points.9a32a3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/252_phase_function_Paper_Points.png
// module id = SLrf
// module chunks = 0